import { Observable } from 'rxjs/Observable';
import { AuthEvents } from './auth/auth-events';
import { Response } from '@angular/http';

import { environment } from '../../environments/environment';

export class BaseService {
  
  gateway = environment.api;

  urls: {
    signup: string,
    verify: string,
    members: string,
    customer: string,
    updateCustomer: string,
    token: string,
    requestResetPassword: string,
    resetPassword: string,
    updatePassword: string,
    changePassword: string,
    gamblings: string,
    cards: string,
    deleteCard: string,
    contactUsCategories: string,
    contactUsComent: string,
   
    states: string,
    prices: string,
    verificationEmail: string,
    favorites: string,
    getFavoritesMelate: string,
    winnerCombinations: string,
    gameVerification: string,
    verifyWinner: string
    
  } = {
    signup: this.gateway + 'ppap/lotto/public/pronosticos/members',
    verify: this.gateway + 'matreshka/private/matreshka/verify',
    members: this.gateway + 'lotto/private/members',
    customer: this.gateway + 'lotto/private/customers',
    updateCustomer: this.gateway + 'lotto/private/customer',
    token: this.gateway + 'ppap/auth/oauth/token',// 'auth/oauth/token',
    requestResetPassword: this.gateway  + 'lotto/public/members/resetPassword',
    updatePassword: this.gateway + 'lotto/public/members/updatePassword',
    resetPassword: this.gateway + '1/user/resetPassword',
    changePassword: this.gateway + '1/user/changePassword',
    gamblings: this.gateway + 'lotto/private/gamblings',
    cards: this.gateway + 'lotto/private/cards',
    deleteCard: this.gateway + 'lotto/private/card',
    contactUsCategories: this.gateway + 'lotto/categories',
    contactUsComent: this.gateway + 'lotto/comment',
   
    states: this.gateway + 'lotto/public/pronosticos/states',
    prices: this.gateway + 'lotto/public/pronosticos/melate/prices',
    verificationEmail: this.gateway + 'lotto/private/members/resendVerificationEmail',
    favorites: this.gateway + 'lotto/private/pronosticos/favorites',
    getFavoritesMelate: this.gateway + 'lotto/private/pronosticos/favorites/Melate',
    winnerCombinations: this.gateway + 'lotto/public/pronosticos/melate/winning',
    gameVerification: this.gateway + 'lotto/private/pronosticos/verification',
    verifyWinner: this.gateway + 'lotto/private/pronosticos/verification'
  };

  constructor() {
  }

  protected handleErrorAsObservable(error: any): Observable<any>{
    return Observable.throw(this._handleError(error));
  }

    protected handleErrorAsPromise(error: any): Promise<any>{
    return Promise.reject(this._handleError(error));
  }

  // TODO manage "unauthorized" extending AuthHttp class
  private _handleError(error: any): String | String[] {
    console.log(error);

    let parsedError: any = null;

    if (error instanceof Response) {

      try {
        parsedError = error.json();
      }
      catch (ex) {
        console.log(ex);
        console.log('Error response is not a json object.');
      }

      if (parsedError) {
        // Check if the reposnse is a validation result
        let isValidationResult: boolean = false;
        let validationErrors = <any>parsedError;
        let flattenErrors: string[] = [];

        Object.keys(validationErrors || {}).every(key => {
          if (Array.isArray(validationErrors[key])) {
            isValidationResult = true;
            validationErrors[key].forEach(errorMessage => {
              flattenErrors.push(errorMessage);
            });
          }
          else {
            isValidationResult = false;
          }
          return isValidationResult;
        });

        if (isValidationResult && flattenErrors.length)
          return flattenErrors;
        else if(parsedError.title)
          return parsedError.title;
        else if(parsedError.detail)
          return parsedError.detail;
        else if(parsedError.message)
          return parsedError.message;
        else if(parsedError.exception)
          return parsedError.exception;
      }
    }

    let errMsg = (error.message) ? error.message : 'Lo sentimos, ocurrió un error. Vuelve a intentarlo.';

    if (error.status === 401) {
      //this.events.publish(AuthEvents.USER_UNAUTHORIZED);
    }
    /*else if (error.status === 409) {
      errMsg = 'El usuario con el que te quieres registrar ya existe.';
    }*/

    return errMsg;
  }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/core/base.service.ts